import { render } from "./OptionsSort.vue?vue&type=template&id=780c2316"
import script from "./OptionsSort.vue?vue&type=script&lang=js"
export * from "./OptionsSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__